import Dropdown from "react-bootstrap/Dropdown";

import { RenderWhen } from "../../components";
import FileAnalysisModal from "../../components/FileAnalysisModal";
import Icon from "../../components/Icon";
import SubmitUrlModal from "../../components/SubmitUrlModal";
import VerticalDivider from "../../components/VerticalDivider";

import { HandleUploadParams } from "../../components/@types/fileanalysisform";
import { UploadState } from "./upload.reducer";

const GlobalUploadButton = ({
  onUpload,
  state,
  analysesState,
  toggleAnalyses,
  closeAnalyses,
  linksReloadDocument
}: {
  onUpload: (params: HandleUploadParams) => void;
  state: UploadState;
  analysesState: { file: boolean; url: boolean };
  toggleAnalyses: (modal: "file" | "url") => void;
  closeAnalyses: () => void;
  linksReloadDocument?: boolean;
}) => (
  <div className="rlbs flex" style={{ alignItems: "center" }}>
    <Dropdown id="global-upload-dropdown" className="global-upload-dropdown">
      <Dropdown.Toggle
        id="global-upload-dropdown__btn"
        size="sm"
        variant="link"
        className="global-upload-dropdown__btn"
        data-testid="global-upload-button"
      >
        <strong
          id="global-upload-dropdown__btn__title"
          className="global-upload-dropdown__title"
        >
          Submit
        </strong>
        <Icon
          id="global-upload-dropdown__btn__icon"
          name="global_upload"
          className="global-upload-dropdown__icon"
        />
      </Dropdown.Toggle>
      <Dropdown.Menu
        renderOnMount
        id="global-upload-dropdown-menu"
        className="dropdown-menu--light global-upload-dropdown__menu"
      >
        <Dropdown.Item
          onClick={() => toggleAnalyses("file")}
          data-testid="global-upload-menu-item-file-analysis"
        >
          File Analysis
        </Dropdown.Item>
        <Dropdown.Item
          onClick={() => toggleAnalyses("url")}
          data-testid="global-upload-menu-item-submit-url"
        >
          URL Analysis
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
    <VerticalDivider color="black" />
    <RenderWhen condition={analysesState.file}>
      <FileAnalysisModal
        state={state}
        showModal={analysesState.file}
        closeModal={closeAnalyses}
        handleUpload={onUpload}
      />
    </RenderWhen>
    <RenderWhen condition={analysesState.url}>
      <SubmitUrlModal
        show={analysesState.url}
        handleShow={closeAnalyses}
        linksReloadDocument={linksReloadDocument}
      />
    </RenderWhen>
  </div>
);

export default GlobalUploadButton;
